<template>
    <div class="row g-3 form-section__title">
        <div class="col-md-12">
            <AppInput
                :name="memberIndex + 'FamilyMember.Relationship'"
                :label="$root.t('step1.relationshipToThePolicyHolder')"
                rules="required"
            >
                <span>&nbsp;&nbsp;</span>
                <i
                    class="fa fa-question-circle cursor-pointer"
                    aria-hidden="true"
                    :title="$t('step1.relationshipToThePolicyHolder')"
                    @click="showRelationshipToPolicyHolderHelperModal()"
                />
                <AppSelect
                    v-model="form.relationshipId"
                    :placeholder="$t('common.defaultSelectionValue')"
                    :options="$optionData.relationships"
                    @input="validateRelationshipToPolicyHolder()"
                />
            </AppInput>
        </div>
        <div class="col-md-6">
            <AppInput :name="memberIndex + 'FamilyMember.Salutation'" :label="$root.t('step1.title')">
                <AppSelect
                    v-model="form.salutationId"
                    :placeholder="$t('common.defaultSelectionValue')"
                    :options="$optionData.titles"
                />
            </AppInput>
        </div>
        <div class="col-md-6">
            <AppInput :name="memberIndex + 'FamilyMember.Forename'" :label="$root.t('step1.forename')" rules="required">
                <Input v-model="form.forename" class-name="form-control" auto-complete="given-name" />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput :name="memberIndex + 'FamilyMember.SurName'" :label="$root.t('step1.surname')" rules="required">
                <Input v-model="form.surname" class-name="form-control" auto-complete="family-name" />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput :name="memberIndex + 'FamilyMember.DateOfBirth'" :label="$root.t('step1.dob')" rules="required">
                <DropdownDatepicker
                    ref="dobDate"
                    v-model="form.dateOfBirth"
                    :min-age="minAge"
                    :max-age="maxAge"
                    :day-label="$t('common.day')"
                    :month-label="$t('common.month')"
                    :year-label="$t('common.year')"
                    @input="validateAgeRelationshipPolicy()"
                />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput :name="memberIndex + 'FamilyMember.Gender'" :label="$root.t('step1.gender')" rules="required">
                <AppSelect
                    v-model="form.genderId"
                    :placeholder="$t('common.defaultSelectionValue')"
                    :options="$optionData.genders"
                />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput
                :name="memberIndex + 'FamilyMember.Occupation'"
                :label="$root.t('step1.occupation')"
                rules="required"
            >
                <AppSelect
                    v-model="form.occupationId"
                    :placeholder="$t('common.defaultSelectionValue')"
                    :options="$optionData.occupations"
                />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput :name="memberIndex + 'FamilyMember.JobTitle'" :label="$root.t('step1.jobTitle')" rules="required">
                <Input v-model="form.jobTitle" class-name="form-control" />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput :name="memberIndex + 'FamilyMember.Industry'" :label="$root.t('step1.industry')" rules="required">
                <Input v-model="form.industry" class-name="form-control" />
            </AppInput>
        </div>

        <div class="col-md-12">
            <AppInput
                :name="memberIndex + 'FamilyMember.CountryOfNationality'"
                :label="$root.t('step1.nationalityCountry')"
                rules="required"
            >
                <AppSelect
                    v-model="form.nationalityCountryId"
                    :placeholder="$t('common.defaultSelectionValue')"
                    :options="$optionData.nationalities"
                    searchable
                />
            </AppInput>
        </div>

        <div v-if="isTaxEnable" class="col-md-6">
            <AppInput :name="memberIndex + 'FamilyMember.TaxIdentificationNumber'" :label="$root.t('step1.tax')">
                <input v-model="form.taxIdentificationNumber" class="form-control" :placeholder="$t('step1.tax')" />
            </AppInput>
        </div>
        <!-- Helper Modal -->
        <AppModal
            :title="helperTitle"
            :content="helperContent"
            :is-open="openHelperModal"
            @onClose="openHelperModal = false"
        />
    </div>
</template>

<script>
import moment from 'moment'
import helper from '../../utils/helper.js'
import AppSelect from '../shared/AppSelect.vue'
import AppInput from '../shared/AppInput.vue'
import Input from '../shared/Input.vue'
import AppModal from '../shared/Modal.vue'
import DropdownDatepicker from '../shared/dropdown-datepicker'

export default {
    name: 'FamilyMemberForm',
    components: {
        AppSelect,
        AppInput,
        // eslint-disable-next-line vue/no-reserved-component-names
        Input,
        AppModal,
        DropdownDatepicker,
    },
    props: {
        form: {
            type: Object,
            required: true,
        },

        memberIndex: { type: Number, required: true },

        print: {
            type: Boolean,
            require: true,
            default: false,
        },
    },
    data() {
        return {
            helperModal: null,
            openHelperModal: false,
            helperTitle: '',
            helperContent: '',

            minAge: 0,
            maxAge: 74,
        }
    },
    computed: {
        isTaxEnable() {
            return this.$formData.policyHolder.details.isTaxEnable
        },
    },
    mounted() {},
    methods: {
        validateRelationshipToPolicyHolder() {
            let res = helper.validateRelationshipToPolicyHolder(
                this.$formData.policyDetails.policyHolderInsured,
                this.$formData.policyHolder.details.occupationId,
                this.$optionData.occupations,
                this.form.relationshipId,
                this.$optionData.relationships,
            )

            if (!res.isValid) {
                this.$toast.open({
                    message: res.message,
                    type: 'error',
                })
            } else {
                let relationship = this.$optionData.relationships.find((r) => r.value === this.form.relationshipId)
                // If checkbox `Policy Holder to be Insured` is checked
                if (
                    this.$formData.policyDetails.policyHolderInsured !== null &&
                    this.$formData.policyDetails.policyHolderInsured
                ) {
                    this.minAge = relationship.minAgeToBeOnPolicy
                    this.maxAge = relationship.maxAgeToBeOnPolicy
                } else {
                    // Uncheck
                    this.minAge = relationship.minAgeToBeOnPolicyWithoutPh
                    this.maxAge = relationship.maxAgeToBeOnPolicyWithoutPh
                }

                this.$refs.dobDate.validateAge(this.minAge, this.maxAge)
            }
        },

        validateAgeRelationshipPolicy() {
            if (!this.form.relationshipId) {
                this.$toast.open({
                    message: this.$t('validate.validateAgeRelationshipPolicy'),
                    type: 'error',
                })
            }

            let minAge = -1
            let maxAge = -1

            let relationship = this.$optionData.relationships.find((r) => r.value === this.form.relationshipId)
            // If checkbox `Policy Holder to be Insured` is checked >>
            if (
                this.$formData.policyDetails.policyHolderInsured !== null &&
                this.$formData.policyDetails.policyHolderInsured
            ) {
                minAge = relationship.minAgeToBeOnPolicy
                maxAge = relationship.maxAgeToBeOnPolicy
            } else {
                // Uncheck
                minAge = relationship.minAgeToBeOnPolicyWithoutPh
                maxAge = relationship.maxAgeToBeOnPolicyWithoutPh
            }

            let res = helper.validateAgePolicy(this.form.dateOfBirth, minAge, maxAge)
            if (!res.isValid) {
                this.$toast.open({
                    message: res.message,
                    type: 'error',
                })

                this.form.dateOfBirth = ''

                setTimeout(() => {
                    this.$refs.dobDate.clearData()
                }, 10)
            }
        },
        getOccupationById() {
            return this.$optionData.occupations.find((o) => o.value === this.form.occupationId).text || ''
        },
        checkFutureDate(date) {
            let today = moment().startOf('day')
            return moment(date).startOf('day') >= today
        },
        showRelationshipToPolicyHolderHelperModal() {
            this.helperTitle = this.$t('popup.relationshipToThePolicyHolder')
            this.helperContent = this.$t('popup.relationshipToThePolicyHolderContent')
            this.openHelperModal = true
        },
    },
}
</script>
